import { FormattedMessage } from 'react-intl'
import { useLocation, useNavigate } from '@tanstack/react-router'

import { Button } from '@gto/ui/button'
import { LockClosedIcon } from '@gto/ui/icons/solid'
import { Paper } from '@gto/ui/paper'
import { Typography } from '@gto/ui/typography'

import { useAuth } from '@/hooks/use-auth'

export const PromoLoginCard = () => {
  const { isAuthorized, isInitialized } = useAuth()
  const navigate = useNavigate()
  const { pathname } = useLocation()
  if (isAuthorized || !isInitialized) {
    return null
  }

  return (
    <Paper
      className="w-full rounded-md border border-divider p-6"
      elevation="2"
    >
      <div className="flex items-center justify-between gap-8">
        <div className="flex grow flex-col gap-6">
          <div className="flex justify-between gap-4">
            <Typography variant="h4">
              <FormattedMessage id="common.labels.trackYourProgress" />
            </Typography>

            <div className="hidden flex-[0_0_auto] text-primary-main sm:block">
              <LockClosedIcon
                height={48}
                width={48}
              />
            </div>
          </div>

          <Typography
            className="whitespace-pre-wrap"
            color="text.secondary"
            variant="body1"
          >
            <FormattedMessage id="common.labels.trackYourProgress.description" />
          </Typography>
          <div className="flex gap-1">
            <Button
              color="primary"
              size="medium"
              variant="contained"
              onClick={() => {
                navigate({
                  to: '/login',
                  viewTransition: true,
                  search: {
                    back_url: pathname,
                  },
                }).catch(console.error)
              }}
            >
              <FormattedMessage id="common.controls.login" />
            </Button>
            <Button
              color="secondary"
              size="medium"
              variant="contained"
              onClick={() => {
                navigate({
                  to: '/login',
                  viewTransition: true,
                  search: { back_url: pathname },
                }).catch(console.error)
              }}
            >
              <FormattedMessage id="common.controls.createAccount" />
            </Button>
          </div>
        </div>
        <div className="block flex-[0_0_auto] text-primary-main sm:hidden">
          <LockClosedIcon
            height={48}
            width={48}
          />
        </div>
      </div>
    </Paper>
  )
}
